import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { Guid } from "@/Common/Models/Guid";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

class EmployeeSearch {
    public Contact_id: Guid;
    public Inactivable_id: Guid;
    public FirstName: string;
    public LastName: string;
    public IsInactive: boolean;
    public IssuingLicenseOrganizationRuleId: string;
    public Type: EmployeeType;
    public User_id: string;
    public UserName: string;
    public PrefixLookupId: string;

    constructor() {
        this.Contact_id = GuidHelper.Empty();
        this.Inactivable_id = GuidHelper.Empty();
        this.IssuingLicenseOrganizationRuleId = GuidHelper.Empty();
        this.User_id = GuidHelper.Empty();
        this.PrefixLookupId = GuidHelper.Empty();
        this.FirstName = "";
        this.LastName = "";
        this.UserName = "";
        this.Type = EmployeeType.None;
        this.IsInactive = false;
    }

    public static fromEmployee(emp: EmployeeUIModel): EmployeeSearch {
        let empSearch = new EmployeeSearch();

        empSearch.Contact_id = emp.ContactId;
        empSearch.Inactivable_id = emp.ContactFacetId;
        empSearch.FirstName = emp.Model.FirstName;
        empSearch.LastName = emp.Model.LastName;
        empSearch.IsInactive = emp.Model.IsInactive;
        empSearch.IssuingLicenseOrganizationRuleId = emp.getIssuingOrgRule()?.Id;
        empSearch.Type = emp.Type;
        empSearch.User_id = emp.Model.User_id;
        empSearch.UserName = emp.Model.UserName;
        empSearch.PrefixLookupId = emp.Model.PrefixLookupId;
        return empSearch;
    }
}

export { EmployeeSearch };
